<script>
export default {
	props: ['showModal', 'isOpen'],
};
</script>

<template>
	<!-- Header links -->
	<div :class="isOpen ? 'block' : 'hidden'"
		class="m-0 sm:ml-4 mt-5 sm:mt-3 sm:flex p-5 sm:p-0 justify-center items-center shadow-lg sm:shadow-none border border-white">

		<a href="#whyoniel"
			class="font-general-medium block text-left text-xl font-medium text-white hover:bg-white hover:text-black border-t-2 px-4 py-3 sm:pt-2 sm:border-t-0 transition duration-200"
			aria-label="WSOP">Mengapa Oniel?</a>
		<a href="#howtovote"
			class="font-general-medium block text-left text-xl font-medium text-white hover:bg-white hover:text-black border-t-2 px-4 py-3 sm:pt-2 sm:border-t-0 transition duration-200"
			aria-label="HowToVote">Cara Gunakan Hak Suara</a>
		<a href="#gerakbersama"
			class="font-general-medium block text-left text-xl font-medium text-white hover:bg-white hover:text-black border-t-2 px-4 py-3 sm:pt-2 sm:border-t-0 transition duration-200"
			aria-label="SSKJKT48">Gerak Bersama</a>
	</div>
</template>

<style lang="scss" scoped></style>
